import React from 'react'
import ToppingItem from './ToppingItem'
import DynamicColor from '../../common/dynamic-color'
import { COLOR_NAME, COMMON_STATUS } from '../../../constants'
import { ensureArray } from '../../../utils/helper'

const GroupTopping = ({
    className = '',
    item = {},
    listChecked = [],
    handleChangeTopping,
    id,
    setMoreInfo
}) => {
    const { food_datas, type } = item;

    return (
        <div id={id} className={`list-topping ${className}`}>
            <DynamicColor
                style={{ color: COLOR_NAME.BODY_TEXT }}
                className="list-topping--title label-2"
            >
                {item.group_name}
            </DynamicColor>

            <div className="list-topping__list">
                {ensureArray(food_datas).map((tp, index) => (
                    <ToppingItem
                        handleChangeTopping={() => handleChangeTopping(index)}
                        checked={(listChecked || [])[index]}
                        item={tp}
                        key={index}
                        type={type}
                        setMoreInfo={setMoreInfo}
                        addable={tp.status === COMMON_STATUS.ACTIVE}
                    />
                ))}
            </div>
        </div>
    )
}

export default GroupTopping
